import React from 'react'
import nail_care from '../../../assets/nail_care.jpg'
import logo from '../../../assets/logo.png'
// import ScrollAnimation from 'react-animate-on-scroll';
// import "animate.css/animate.min.css";



import './Services.css'

const Services = ({ heading, intro, cards }) => {
    return (
        <div className='services' id='what-we-do'>

            <div className='services-container'>

                <div className='services-info'>
                    <img src={logo} alt=''></img>
                    <h1>{heading}</h1>
                    {intro?.map((paragraph, index) => (
                        <p className='mr-bottom services-para' key={`${paragraph}-${index}`}>
                            {paragraph}
                        </p>
                    ))}
                </div>

                <div className='services-grid'>
                    {cards?.map((card, index) => (
                        <div className='services-box' key={`${card.title}-${index}`}>
                            <img src={nail_care} alt=''></img>
                            <h2>{card.title}</h2>
                            {card.description?.map((line, lineIndex) => (
                                <p className='mr-bottom services-para' key={`${line}-${lineIndex}`}>
                                    {line}
                                </p>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Services
